<template>
  <div class="desktop-menu-layout mobile-menu-layout sticky-footer-layout">
    <div id="app">
      <div id="pageTop"></div>
      <!-- desktop menu -->
      <!-- main page -->
      <!-- mobile menu -->
      <!-- footer -->
    </div>
  </div>
</template>

<script>
export default {
  name: "bc-page",
};
</script>

<style lang="scss" scoped>
</style>